import { render, staticRenderFns } from "./create-category-modal.vue?vue&type=template&id=4acb0676&scoped=true"
import script from "./create-category-modal.vue?vue&type=script&lang=js"
export * from "./create-category-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb0676",
  null
  
)

export default component.exports